/**
 * Registro de pods, carregado de `GET instancias-whatsapp/pods`.
 */

let PODS = [];
let promessa = null;

export function carregarPods(http, forcar = false, atualizarEstado = false) {
    if (forcar) {
        promessa = null;
    }

    if (!promessa) {
        const url = atualizarEstado ? 'instancias-whatsapp/pods?atualizar=1' : 'instancias-whatsapp/pods';

        promessa = http.get(url)
            .then(({ data }) => {
                PODS = (data && data.data) || [];
                return PODS;
            })
            .catch((e) => {
                promessa = null;
                throw e;
            });
    }

    return promessa;
}

export function invalidar() {
    promessa = null;
}

export function pods() {
    return PODS;
}

export function ativos() {
    return PODS.filter(p => p.ativo);
}

export function porEndereco(endereco) {
    return PODS.find(p => p.endereco === endereco) || null;
}

/** Nome do pod quando ele está no registro; o endereço cru quando não está. */
export function nomeDoEndereco(endereco) {
    const pod = porEndereco(endereco);
    return pod ? pod.nome : endereco;
}

/** Hosts distintos, para o filtro. */
export function hosts() {
    return [...new Set(PODS.map(p => p.host))];
}
